// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kL8LI8Jh8M8OAb11PFTK{visibility:hidden;margin-right:5px}.bPzwbZzqZMUuerBlzRwm,.ubxqUCVPpEkdijanC_IO{visibility:visible}.ubxqUCVPpEkdijanC_IO{transform:scale(1, -1)}`, "",{"version":3,"sources":["webpack://./ui-kit/Table/TableHeadSortIcon/TableHeadSortIcon.module.scss"],"names":[],"mappings":"AAAA,sBACE,iBAAA,CACA,gBAAA,CACA,4CACE,kBAAA,CAEF,sBACE,sBAAA","sourcesContent":[".sort-icon {\r\n  visibility: hidden;\r\n  margin-right: 5px;\r\n  &--ascend, &--descend {\r\n    visibility: visible;\r\n  }\r\n  &--descend {\r\n    transform: scale(1, -1);\r\n  }\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sort-icon": `kL8LI8Jh8M8OAb11PFTK`,
	"sort-icon--ascend": `bPzwbZzqZMUuerBlzRwm`,
	"sort-icon--descend": `ubxqUCVPpEkdijanC_IO`
};
export default ___CSS_LOADER_EXPORT___;
